import React from "react";

const services = ["Other Service", "Website Creation", "Website Maintainance", "ID Card"];

const Service = ({ selectedServices, setSelectedServices }) => {
  const handleCheckboxChange = (service) => {
    setSelectedServices((prevState) => {
      const newState = { ...(prevState || {}) };
      if (newState[service]) {
        delete newState[service];
      } else {
        newState[service] = { Amount: "", GST: "", Description: "" };
      }
      return newState;
    });
  };

  const handleInputChange = (service, field, value) => {
    setSelectedServices((prevState) => ({
      ...(prevState || {}),
      [service]: {
        ...(prevState?.[service] || {}),
        [field]: value,
      },
    }));
  };

  return (
    <div>
      {services.map((item) => (
        <div
          key={item}
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: 10,
            flexWrap: "wrap",
            gap: 10,
          }}
        >
          <input
            type="checkbox"
            style={{ width: 20, height: 20 }}
            checked={!!selectedServices?.[item]}
            onChange={() => handleCheckboxChange(item)}
          />
          <div style={{ width: 200 }}>{item}</div>
          {selectedServices?.[item] && (
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
              <input
                type="number"
                placeholder="Enter amount"
                value={selectedServices[item]?.Amount ?? ""}
                onChange={(e) => handleInputChange(item, "Amount", e.target.value)}
                min="1"
                max="1000000"
              />
              <input
                type="number"
                placeholder="Enter GST"
                value={selectedServices[item]?.GST ?? ""}
                onChange={(e) => handleInputChange(item, "GST", e.target.value)}
                min="0"
                max="100"
              />
              <input
                type="text"
                placeholder="Enter Description"
                value={selectedServices[item]?.Description ?? ""}
                onChange={(e) => handleInputChange(item, "Description", e.target.value)}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Service;


